import TextField from "@mui/material/TextField";
import { Stack } from "@mui/system";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";

// Disabled/display-only date range field shared by Anomalies > Missing Data
// and FTD. Neither tab's window is user-adjustable (Missing Data is always
// the last 2 days; FTD's spec calls the range "fixed and disabled"), so this
// mirrors the same read-only pattern already used by Budget/Be Aware mobile.
interface AnomaliesDateRangeFieldProps {
  label: string;
}

const AnomaliesDateRangeField = ({ label }: AnomaliesDateRangeFieldProps) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <TextField
        size="small"
        value={label}
        disabled
        slotProps={{ input: { readOnly: true } }}
        sx={{
          width: "100%",
          padding: "2px !important",
          "& .MuiInputBase-input": {
            fontSize: typography.Size.Text.sm.$value,
            lineHeight: typography.Line_height.text.sm.$value,
            fontWeight: typography.Font_weight.Semibold.$value,
            py: "5px !important",
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: spacing.Radius.md.$value,
            "&.Mui-focused fieldset": {
              borderColor: colors.GrayLightMode[300].$value,
              borderWidth: "1px",
            },
          },
        }}
      />
    </Stack>
  );
};

export default AnomaliesDateRangeField;
